import React, { useEffect, useMemo, useState } from "react";
import useFlex from "hooks/useFlex";
import {
  BaseInput,
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import { SideNav } from "components";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { useLocation, useNavigate } from "react-router";
import { CardSelectorWrapper } from "components/CardSelector/styles";
import Card from "components/CardSelector/Card";
import { Form, Formik } from "formik";
import { ButtonWrapper } from "pages/PlanSelection";
import http from "services/httpService";
import * as Yup from "yup";
import GradeOther from "pages/GradeSetup/GradeOther";
import { DisplayName, removeCommas, rupeesToNumber } from "utlis/utils";
import routes from "components/routes";
import { fetchUniversalSetupMasterSelected } from "../schema";
import { HomeWrapper } from "components/CdBalance/style";
import BaseTextArea from "components/BaseTextArea";
import { colors } from "theme";
import { Padding } from "@mui/icons-material";

const options = ["Yes", "No"];

function CorporateBufferPreIssuance() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [choice, setChoice] = useState("");

  const selectedValues = useMemo(() => {
    let selectedValues = localStorage.getItem("eb_selected_values");
    if (selectedValues) {
      selectedValues = JSON.parse(selectedValues);
    }
    return selectedValues;
  }, []);

  const userplanId = useMemo(() => {
    return localStorage.getItem("eb_current_plan");
  }, []);

  const resetPlan = (value) => {
    setChoice(value);
  };

  useEffect(() => {
    (async function () {
      await fetchUniversalSetupMasterSelected();
      setLoader(false);
    })();
  }, []);

  const productName = useMemo(() => {
    if (!selectedValues || !userplanId) return;
    const name =
      selectedValues.userplans_data[userplanId].product_type.display_name ||
      selectedValues.userplans_data[userplanId].product_type.product_type_name;
    return DisplayName(name);
  }, [userplanId, selectedValues]);

  useEffect(() => {
    if (selectedValues) {
      const prevCorporateBufferDetails =
        selectedValues.userplans_data[userplanId][
          "userplan_corporate_buffer_data"
        ];
      if (prevCorporateBufferDetails?.corporate_buffer) {
        setChoice("Yes");
      } else {
        setChoice("No");
      }
    }
  }, [selectedValues]);

  const handleSubmit = async (value) => {
    if (!userplanId) return;
    if (choice === "No") {
      value.amount = "";
    }
    try {
      let corporate_buffer_status;
      if (choice == "Yes") {
        corporate_buffer_status = true;
      } else {
        corporate_buffer_status = false;
      }
      const payload = {
        userplan_id: userplanId,
        corporate_buffer_status,
        corporate_buffer_limit: removeCommas(value.amount),
        remark: value.remark,
      };
      const data = await http.post(
        "/business/corporate_buffer_details/",
        payload
      );
      navigate(`/${routes.UNIVERSAL_TPA}`);
    } catch (e) {
      console.log(e);
    }
  };
  const validationSchema = () => {
    let schema = Yup.object();

    if (choice === "Yes") {
      schema = schema.shape({
        amount: Yup.string().required("*Please enter Amount."),
      });
    }
    return schema;
  };

  const initialValues = useMemo(() => {
    if (selectedValues) {
      const prevCorporateBufferDetails =
        selectedValues.userplans_data[userplanId][
          "userplan_corporate_buffer_data"
        ];
      return {
        amount: prevCorporateBufferDetails?.corporate_buffer_limit,
        remark: prevCorporateBufferDetails?.corporate_buffer_terms,
      };
    }
    return {
      amount: "",
      remark: "",
    };
  }, [selectedValues]);
  console.log({ initialValues });
  return (
    <section>
      {loader ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <HomeWrapper style={{}}>
            <PageTitle title={`Setup ${productName}`} />
            <WidthLimiter>
              <Ptag
                marginTop="36px"
                fontSize="14px"
                marginBottom="12px"
              >
                Would like to add Corporate Buffer?
              </Ptag>
              <CardSelectorWrapper>
                {options.map((display_name, index) => (
                  <Card
                    key={index}
                    title={display_name}
                    selected={choice === display_name}
                    onChange={() => resetPlan(display_name)}
                  />
                ))}
              </CardSelectorWrapper>
              {
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {(formikProps) => (
                    <div style={{ marginBottom: "2.8rem" }}>
                      <Form
                        style={{
                          flexDirection: "column",
                          gap: "2rem",
                        }}
                      >
                        {choice === "Yes" && (
                          <div
                            style={{
                              paddingTop: "36px",
                            }}
                          >
                            <div style={{
                              width: "300px"
                            }}>
                              <BaseInput
                                formatToIndianNumbering
                                staticLabel="Enter Corporate Buffer Amount"
                              fontSize="16px !important"        
                     style={{Padding:"16px"}}
                                formikProps={{
                                  ...formikProps,
                                  name: "amount",
                                }}
                              />
                            </div>
                            <div style={{ marginTop: "36px" }}>
                              <Ptag
                                color={colors.primaryColor}
                                fontSize="14px"
                                marginBottom="10px"
                              >
                                Terms and Conditions
                              </Ptag>
                              <BaseTextArea name="remark" />
                            </div>
                          </div>
                        )}
                        <section
                          style={{
                            marginTop: "12rem",
                          }}
                        >
                          <ButtonWrapper>
                            <LargeButton
                              id=""
                              label={"Next"}
                              type="submit"
                              style={{width:'932px'}}
                              // onClick={() => handleSubmit()}
                            />
                          </ButtonWrapper>
                        </section>
                      </Form>
                    </div>
                  )}
                </Formik>
              }
            </WidthLimiter>
          </HomeWrapper>
        </>
      )}
    </section>
  );
}

export default CorporateBufferPreIssuance;
